import Ad from '../ad';
import { AdFramework, SIDEBAR_AD_MIN_VIEWPORT_WIDTH } from '../ad-framework';
import { IS_DEV } from '../../data/js/server-constants';

/**
 * The 160x600 rail beside every listing grid: search, browse, shop, tags, For
 * You and the seller page. It was pasted into three components; the seller
 * copy alone also rendered in development.
 */
const GridSidebarAd = () => {
  if (IS_DEV) return null;
  return (
    <div className="sidebar-ad" data-testid="grid-sidebar-ad">
      <div className="sidebar-ad-cont">
        <AdFramework
          minViewportWidth={SIDEBAR_AD_MIN_VIEWPORT_WIDTH}
          bidstream={{
            desktop: (
              <div
                data-ad-tagid="ku8KAIhHnhaVwj4aoncD"
                data-zid="1017"
                data-name="SW - sellwild.com desktop 160x600"
              />
            ),
          }}
          adsense={
            <Ad
              key="9551701632"
              className="adsbygoogle"
              style={{ display: 'block', margin: 'auto', width: 160, height: 600 }}
              data-ad-client="ca-pub-3154552656014103"
              data-ad-slot="9551701632"
            />
          }
        />
      </div>
      <div id="first-leaderboard" />
    </div>
  );
};

export default GridSidebarAd;
